<template>
    <div class="z-checkbox-group vm-form-el">
        <div
            class="z-checkbox-wrapper"
            v-for="(item, i) in items"
            :key="i"
        >
            <label
                :for="item.id"
                class="z-checkbox"
                :class="{
                    'is-checked': arLocalСhecked.indexOf(item.value) >= 0,
                    'is-disabled': item.disabled
                }"
            >
                <input
                    :id="item.id"
                    :value="item.value"
                    v-model="arLocalСhecked"
                    :name="name"
                    :disabled="item.disabled"
                    @change="onChange()"
                    type="checkbox"
                />
                <span class="z-checkbox__box"></span>
                <span class="z-checkbox__text" v-html="item.text"></span>
            </label>
        </div>
        <div class="z-checkbox-group__details">
            <span
                class="z-checkbox__error vm-form-el__error"
                v-show="required && error"
            >
                <span v-show="arLocalСhecked.length === 0">{{ text.error }}</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'z-checkbox-group',
    props: {
        items: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        required: Boolean
    },
    data () {
        return {
            arLocalСhecked: [],
            error: false,
            focus: false,
            text: {
                error: this.$root.lang === 'ru' ? 'Поле обязательно для заполнения' : 'Required field'
            }
        }
    },
    created () {
        this.arLocalСhecked = this.items.filter(obj => obj.checked).map(obj => obj.value)
    },
    methods: {
        onChange () {
            this.validate()
        },
        validate () {
            if (this.required && this.arLocalСhecked.length === 0) {
                this.error = true
            } else {
                this.error = false
            }
        }
    }
}
</script>
